import styled from "styled-components";

export const ThankYouBackground = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  backdrop-filter: blur(3px);
  background-color: rgba(73, 73, 73, 0.3);
  cursor: pointer;
`

export const ThankYouContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  max-width: 800px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  padding: 20px;
  color: #2E3A59;

  @media (min-width: 651px) {
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 650px) {
    left: 5%;
    transform: translate(-2.5%, -50%);
  }
`

export const ThankYouCloseIcon = styled.i`
  display: flex;
  align-self: flex-end;
  margin-right: 15px;
  font-size: 30px;
  color: var(--color-navigation);
  cursor: pointer;
`

export const ThankYouHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const ThankYouBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const ThankYouBodyRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;

  @media (max-width: 550px) {
    flex-direction: column;
  }
`

export const ThankYouBodyLeft = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 240px;

  @media (max-width: 550px) {
    align-items: center;
  }
`

export const ThankYouBodyRight = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: 240px;

  @media (max-width: 550px) {
    align-items: center;
  }
`

export const ThankYouSubHead = styled.p`
  color: var(--color-order-detail-subtext);
  font-size: var(--font-size-sm);
  margin: 10px 0;
`

export const ThankYouTitle = styled.h1`
  color: var(--color-secondary-text);
  font-size: var(--font-size-l);
  font-weight: var(--font-weight-normal);
  margin: 20px 0;
`

export const ThankYouAmount = styled.p`
  font-size: var(--font-size-xl);
  font-weight: 500;
`

export const ThankYouAmountSmall = styled.p`
  font-size: var(--font-size-l);
  font-weight: 500;
  margin-right: 5px;
  margin-bottom: 2px;
`

export const ThankYouAmountWrapper = styled.div`
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  color: var(--color-order-detail-subtext);
  align-items: end;
`

export const ThankYouIconWrapper = styled.div`
  display: flex;
  height: 120px;
  width: 120px;
  border-radius: 50%;
  background-color: var(--color-primary);
  justify-content: center;
  align-items: center;
  position: relative;
`

export const ThankYouIconOutline = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  position: relative;
`

export const ThankYouIconCircle = styled.div`
  position: absolute;
  top: -4px;
  left: -4px;
  background-color: var(--color-primary);
  height: 40px;
  width: 40px;
  transform: rotate(-30deg);
  border-radius: 50%;
  border: solid 4px white;
  border-right-color: transparent;
  z-index: 2;
`

export const TopCircle = styled.div`
  position: absolute;
  top: -4px;
  left: -4px;
  height: 40px;
  width: 40px;
  transform: rotate(-10deg);
  border-radius: 50%;
  border: solid 4px transparent;
  border-top-color: white;
  z-index: 3;
`

export const BottomCircle = styled.div`
  position: absolute;
  top: -4px;
  left: -4px;
  height: 40px;
  width: 40px;
  transform: rotate(-50deg);
  border-radius: 50%;
  border: solid 4px transparent;
  border-bottom-color: white;
  z-index: 4;
`

export const ThankYouIcon = styled.i`
  color: white;
  font-size: 2.7rem;
  margin-left: 14px;
  margin-bottom: 12px;
  z-index: 999;
`

export const ThankYouBodyText = styled.p`
  color: var(--color-secondary-text);
  font-size: var(--font-size-sm);
  width: 75%;
  margin: 10px 0;
`

export const ThankYouFooter = styled.div`
  display: flex;
  margin: 20px 0;
  align-items: center;
  justify-content: center;
`

export const ThankYouFootersdw = styled.div`
  display: flex;
  flex-direction: row;
  width: 210px;
  height: 30px;
  font-size: var(--font-size-l);
  color: var(--color-order-detail-subtext);
  align-items: center;
  justify-content: space-between;
`
